import { missingValue } from "./missingValue.js";

export function toFractionValue(input: number): number {
  return isNaN(input) ? missingValue : input;
}
